import { useSelector } from "react-redux";
import { useRefreshToken } from "../Hooks/useRefreshToken";
import { placeKioskOrder } from "../services/api";
import { useConfig } from "../App";
export const useOrder = () => {
  const cfg = useConfig(); 
  const proxyString = cfg.config.services.PROXY_STRING;
  const orderApiString = cfg.config.services.ORDER_API_STRING;
  const apiUrl = `${proxyString}${orderApiString}`;
  const sourceHeader = cfg.config.services.API_SOURCE_HEADER;
  let currentToken =  useSelector((state) => state.auth.accessToken);
  const refreshTokenSaved = useSelector((state) => state.auth.refreshToken);
  const userName = useSelector((state) => state.auth.userProfile.username);
  const currentTokenExpiresAt =useSelector((state) => state.auth.expiresAt);
  const currentTime = Date.now();
  const {refreshToken} = useRefreshToken();
  
  const submitOrder = async(payload) => {
  // check access token
  if(currentTime >= currentTokenExpiresAt)
  {
    // if accesstoken expires , call refresh token
    const refreshTokenData = await refreshToken(refreshTokenSaved,userName);
    currentToken = refreshTokenData.accessToken;  // change access token
  }
  // call Order API service function
  try{
    const responseData = await placeKioskOrder(payload,currentToken,apiUrl,sourceHeader);
    return responseData.data;
  }
  catch(error){
      console.log("API ERROR", error);
      return error;
  }
}
 return { submitOrder };
}
